import React from 'react';
import { motion } from 'framer-motion';
import { Smartphone, Sun, BarChart3, Globe, TrendingUp, Zap, Smile } from 'lucide-react';
export function SoftwareSlide() {
  return <div className="h-full w-full flex flex-col md:flex-row items-start md:items-center md:justify-center px-4 md:px-16 bg-[#11166b] gap-8 md:gap-16 overflow-y-auto md:overflow-hidden py-16 md:py-0" data-id="element-156">
      <motion.div initial={{
      opacity: 0,
      x: -50
    }} animate={{
      opacity: 1,
      x: 0
    }} transition={{
      duration: 0.8
    }} className="flex-1 max-w-lg w-full mt-4 md:mt-0" data-id="element-157">
        <div className="w-12 h-12 md:w-16 md:h-16 bg-[#00d8a8]/10 rounded-2xl flex items-center justify-center mb-6 md:mb-8" data-id="element-158">
          <Smartphone className="w-6 h-6 md:w-8 md:h-8 text-[#00d8a8]" data-id="element-159" />
        </div>

        <h2 className="text-3xl md:text-5xl font-bold text-white mb-4 md:mb-6" data-id="element-160">
          Smart Charging <br data-id="element-161" />
          <span className="text-[#00d8a8]" data-id="element-162">Energy Management</span>
        </h2>

        <p className="text-base md:text-lg text-slate-300 mb-6 md:mb-8 leading-relaxed" data-id="element-163">
          Deliver a premium experience to your drivers through our white-label
          application or integrate directly via API in your own proposition.
        </p>

        <div className="space-y-4 md:space-y-6" data-id="element-164">
          <div className="flex gap-4" data-id="element-165">
            <div className="w-10 h-10 rounded-full bg-[#0d1155] flex items-center justify-center flex-shrink-0 border border-[#1a2080]" data-id="element-166">
              <Smile className="w-5 h-5 text-[#00d8a8]" data-id="element-167" />
            </div>
            <div data-id="element-168">
              <h4 className="text-white font-semibold text-sm md:text-base" data-id="element-169">
                Easy for EV Drivers
              </h4>
              <p className="text-xs md:text-sm text-slate-400" data-id="element-170">
                Set it once and forget it. Smart charging happens automatically.
              </p>
            </div>
          </div>

          <div className="flex gap-4" data-id="element-171">
            <div className="w-10 h-10 rounded-full bg-[#0d1155] flex items-center justify-center flex-shrink-0 border border-[#1a2080]" data-id="element-172">
              <Sun className="w-5 h-5 text-yellow-500" data-id="element-173" />
            </div>
            <div data-id="element-174">
              <h4 className="text-white font-semibold text-sm md:text-base" data-id="element-175">
                Solar Optimization
              </h4>
              <p className="text-xs md:text-sm text-slate-400" data-id="element-176">
                Maximize self-consumption
              </p>
            </div>
          </div>

          <div className="flex gap-4" data-id="element-177">
            <div className="w-10 h-10 rounded-full bg-[#0d1155] flex items-center justify-center flex-shrink-0 border border-[#1a2080]" data-id="element-178">
              <BarChart3 className="w-5 h-5 text-[#00d8a8]" data-id="element-179" />
            </div>
            <div data-id="element-180">
              <h4 className="text-white font-semibold text-sm md:text-base" data-id="element-181">
                Load balancing
              </h4>
              <p className="text-xs md:text-sm text-slate-400" data-id="element-182">
                Smart peak shaving
              </p>
            </div>
          </div>

          <div className="flex gap-4" data-id="element-183">
            <div className="w-10 h-10 rounded-full bg-[#0d1155] flex items-center justify-center flex-shrink-0 border border-[#1a2080]" data-id="element-184">
              <TrendingUp className="w-5 h-5 text-[#00d8a8]" data-id="element-185" />
            </div>
            <div data-id="element-186">
              <h4 className="text-white font-semibold text-sm md:text-base" data-id="element-187">
                Dynamic Prices
              </h4>
              <p className="text-xs md:text-sm text-slate-400" data-id="element-188">
                Optimize charging based on real-time energy pricing
              </p>
            </div>
          </div>

          <div className="flex gap-4" data-id="element-189">
            <div className="w-10 h-10 rounded-full bg-[#0d1155] flex items-center justify-center flex-shrink-0 border border-[#1a2080]" data-id="element-190">
              <Globe className="w-5 h-5 text-purple-500" data-id="element-191" />
            </div>
            <div data-id="element-192">
              <h4 className="text-white font-semibold text-sm md:text-base" data-id="element-193">
                Universal Access
              </h4>
              <p className="text-xs md:text-sm text-slate-400" data-id="element-194">
                Same app for drivers regardless of charger hardware
              </p>
            </div>
          </div>
        </div>
      </motion.div>

      <motion.div initial={{
      opacity: 0,
      x: 50
    }} animate={{
      opacity: 1,
      x: 0
    }} transition={{
      duration: 0.8,
      delay: 0.2
    }} className="flex-1 flex justify-center w-full pb-24 md:pb-0" data-id="element-195">
        <div className="relative w-56 h-[464px] md:w-72 md:h-[580px] bg-[#0d1155] rounded-[2.5rem] md:rounded-[3rem] border-8 border-[#1a2080] shadow-2xl overflow-hidden" data-id="element-196">
          {/* Phone Screen Mockup */}
          <div className="absolute top-0 left-0 right-0 h-full bg-[#11166b] flex flex-col" data-id="element-197">
            {/* Status Bar */}
            <div className="h-8 w-full flex justify-between items-center px-6 text-[10px] text-white" data-id="element-198">
              <span data-id="element-199">9:41</span>
              <div className="flex gap-1" data-id="element-200">
                <div className="w-3 h-3 bg-white rounded-full opacity-20" data-id="element-201"></div>
                <div className="w-3 h-3 bg-white rounded-full opacity-20" data-id="element-202"></div>
              </div>
            </div>

            {/* App Content */}
            <div className="flex-1 p-4 md:p-6 flex flex-col gap-3 md:gap-4" data-id="element-203">
              <div className="bg-[#00d8a8] rounded-2xl p-4 md:p-6 text-white shadow-lg shadow-[#00d8a8]/20" data-id="element-204">
                <div className="text-xs opacity-70 mb-1" data-id="element-205">Current Status</div>
                <div className="text-xl md:text-2xl font-bold mb-3 md:mb-4" data-id="element-206">
                  Charging
                </div>
                <div className="flex justify-between items-end" data-id="element-207">
                  <div className="text-3xl md:text-4xl font-bold" data-id="element-208">
                    7.4
                    <span className="text-base md:text-lg font-normal opacity-70" data-id="element-209">
                      kW
                    </span>
                  </div>
                  <div className="text-xs md:text-sm opacity-70" data-id="element-210">85% Full</div>
                </div>
              </div>

              <div className="grid grid-cols-2 gap-3 md:gap-4" data-id="element-211">
                <div className="bg-[#0d1155] border border-[#1a2080] rounded-2xl p-3 md:p-4" data-id="element-212">
                  <Sun className="w-5 h-5 md:w-6 md:h-6 text-yellow-500 mb-2" data-id="element-213" />
                  <div className="text-[10px] md:text-xs text-slate-400" data-id="element-214">
                    Solar
                  </div>
                  <div className="text-base md:text-lg font-bold text-white" data-id="element-215">
                    2.1 kW
                  </div>
                </div>
                <div className="bg-[#0d1155] border border-[#1a2080] rounded-2xl p-3 md:p-4" data-id="element-216">
                  <Zap className="w-5 h-5 md:w-6 md:h-6 text-[#00d8a8] mb-2" data-id="element-217" />
                  <div className="text-[10px] md:text-xs text-slate-400" data-id="element-218">
                    Saved
                  </div>
                  <div className="text-base md:text-lg font-bold text-white" data-id="element-219">
                    €12.50
                  </div>
                </div>
              </div>

              <div className="mt-auto bg-[#0d1155] border border-[#1a2080] rounded-2xl p-3 md:p-4" data-id="element-220">
                <div className="text-xs md:text-sm font-medium text-white mb-2" data-id="element-221">
                  Smart Schedule
                </div>
                <div className="h-2 bg-[#1a2080] rounded-full overflow-hidden" data-id="element-222">
                  <div className="h-full w-2/3 bg-[#00d8a8] rounded-full" data-id="element-223"></div>
                </div>
                <div className="flex justify-between text-[10px] md:text-xs text-slate-400 mt-2" data-id="element-224">
                  <span data-id="element-225">00:00</span>
                  <span data-id="element-226">12:00</span>
                  <span data-id="element-227">24:00</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </motion.div>
    </div>;
}